import { LayoutState } from '~/src/stores/layout'
import LayoutServiceInterface, { GetLayoutArgs } from '~/src/utils/layout/LayoutServiceInterface'

export default class LayoutCategoryProductsServiceStyleTwo implements LayoutServiceInterface {
  public getLayout({ isMobile }: GetLayoutArgs): Partial<LayoutState> {
    return {
      header: {
        display: true,
        displayMenuBurger: false,
        displayCart: false,
        displayCurrentFirm: !isMobile,
        displayDeliveryOptions: !!isMobile,
        displayLanguagesSelector: false,
        displayUserActions: !!isMobile,
        displayProductSearch: false,
        displayLocationSearch: false,
        logo: {
          disableLink: false
        },
        title: '',
        type: isMobile ? 'default' : 'navigation'
      },
      subHeader: {
        display: true,
        variant: 'default'
      },
      content: {
        displayNotification: true
      },
      mainSideBar: {
        display: true,
        displayCart: true,
        displayDeliveryOptions: false,
        displayOrderSummary: false
      },
      footer: {
        display: false,
        displayGoToCheckoutBtn: false,
        displayGoToCartBtn: false,
        displayInformations: false,
        displayLinks: false
      },
      mobileNavigation: {
        display: true
      }
    }
  }
}
